import styled from 'styled-components';
export const Image = styled.img `
  margin: 24px 0px 20px;
  width: 100%;
`;
